import httpClient from '../httpClient';

const get = async (id) => {
  return await httpClient.get(`/term_resume_contract/${id}`);
};

const getAllBySelf = async () => {
  return await httpClient.get(`/term_resume_contract/`);
};

const reject = async (id) => {
  return await httpClient.get(`/term_resume_contract/${id}/reject/`);
};

const saveAuths = async (id, data) => {
  return await httpClient.put(`/term_resume_contract/${id}/save_auths/`, data);
};

const saveDocs = async (id, data) => {
  return await httpClient.put(`/term_resume_contract/${id}/save_docs/`, data);
};

const sign = async (id) => {
  return await httpClient.put(`/term_resume_contract/${id}/sign/`);
};
const filtersearch = async (query) => {
  return await httpClient.get(`/contract_process_search/${query}`);
};

export { get, getAllBySelf, filtersearch, reject, saveAuths, saveDocs, sign };
